export default __webpack_public_path__ + "static/media/resturent.6fd0a8a4.jpg";